<template>
  <div>
    <hr-dialog
      width="80%"
      :visible.sync="visible"
      :title="title"
      :handleClose="handleClose"
      operatorModel="view"
    >
      <template slot="body">
        <el-form :inline="true" ref="query">
          <el-row :gutter="24">
            <el-col span="6" style="padding-left: 10px">
              <el-form-item label="车场名称:">
                <el-input disabled v-model="spaceName"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div>
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
            @selection-change="selectionChange"
          >
          </avue-crud>
        </div>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import { getShopRechargeDetailList } from '@/api/v4ward/park/couponv2/shop/carcouponshop';

export default {
  components: {},
  props: {
    shopId: '',
    visible: false,
  },
  data() {
    return {
      spaceName: '',
      data: [],
      title: '充值记录',
      option: {
        index: true,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'center',
        refreshBtn: false,
        viewBtn: false,
        searchBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'spaceName',
            hide: true,
            display: false,
          },
          {
            label: '商家名称',
            prop: 'shopName',
          },
          {
            label: '充值金额',
            prop: 'rechargeAmount',
          },
          {
            label: '优惠折扣',
            prop: 'discountName',
          },
          {
            label: '优惠金额',
            prop: 'discountAmount',
          },
          {
            label: '实收金额',
            prop: 'payAmount',
          },
          {
            label: '充值方式',
            prop: 'payType',
            type: 'select',
            dicData: [
              {
                label: '现金',
                value: 0,
              },
            ],
          },
          {
            label: '操作人',
            prop: 'operateName',
          },
          {
            label: '充值时间',
            prop: 'payTime',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
    };
  },
  watch: {
    visible() {
      this.$emit('update:visible', this.visible);
    },
  },
  created() {},
  methods: {
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad();
    },
    handleClose() {},
    onLoad() {
      this.loading = true;
      if (this.shopId) {
        getShopRechargeDetailList(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            { shopId: this.shopId }
          )
        )
          .then(({ data }) => {
            this.spaceName = data.records[0].spaceName;
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style></style>
